var render, staticRenderFns
import script from "./JourneyBuilderComposerConnectionManager.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderComposerConnectionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45aedf19')) {
      api.createRecord('45aedf19', component.options)
    } else {
      api.reload('45aedf19', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBuilderComposerConnectionManager.vue"
export default component.exports